import styled from 'styled-components'

export const SvgIcon = styled.svg.attrs({ viewBox: '0 0 40 40' })`
  width: 1em;
  height: 1em;
  font-size: inherit;
  fill: currentcolor;
`
